import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Wallet } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { KenoWallet } from '../keno/KenoWallet';
import { KENO_API, gameHeaders } from '../keno/fairnessApi';
import '../keno/keno.css';

export const AccountWalletDialog = ({ onClose }) => {
  const [wallet, setWallet] = useState(null), [error, setError] = useState('');
  const [refresh, setRefresh] = useState(0);
  const syncWallet = useCallback((next) => setWallet((current) => !current || next.revision >= current.revision ? next : current), []);
  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      try {
        const { data } = await axios.get(`${KENO_API}/keno/wallet`, { headers: { ...gameHeaders(false), 'X-GV-Real-Wallet': 'true' }, signal: controller.signal });
        syncWallet(data); setError('');
      } catch (failure) { if (!axios.isCancel(failure)) setError('Unable to refresh your balances.'); }
    };
    load();
    window.addEventListener('gv-wallet-updated', load);
    const timer = setInterval(() => { if (!document.hidden) load(); }, 5000);
    return () => { controller.abort(); clearInterval(timer); window.removeEventListener('gv-wallet-updated', load); };
  }, [syncWallet, refresh]);
  return <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}><DialogContent className="keno-dialog finance-dialog" data-testid="account-wallet-dialog">
    <DialogHeader><DialogTitle className="account-wallet-heading" data-testid="account-wallet-title"><Wallet size={20} />Wallet</DialogTitle><DialogDescription className="sr-only">Playing balance, vault and credit transfers.</DialogDescription></DialogHeader>
    {error && <div role="alert" data-testid="account-wallet-error"><p>{error}</p><Button type="button" variant="outline" data-testid="account-wallet-retry" onClick={() => setRefresh((value) => value + 1)}>Retry</Button></div>}
    {wallet ? <KenoWallet game={{ wallet, syncWallet, demo: false, busy: false, auto: false }} onClose={onClose} /> : !error && <p role="status" data-testid="account-wallet-loading">Loading balances…</p>}
  </DialogContent></Dialog>;
};